// Environment configuration
const toWebSocketUrl = (apiBaseUrl) => {
    try {
        const url = new URL(apiBaseUrl)
        url.protocol = url.protocol === "https:" ? "wss:" : "ws:"
        return url.toString().replace(/\/$/, "")
    } catch {
        return apiBaseUrl
    }
}

const getEnvironmentConfig = () => {
    // Get environment from various sources
    const env = process.env.REACT_APP_ENV || "local"

    const configs = {
        local: {
            API_BASE_URL: "https://platform-order.local.link",
            KEYCLOAK_URL: "https://platform-order.local.link/idp",
            KEYCLOAK_REALM: "products",
            KEYCLOAK_CLIENT_ID: "platform-ui",
        },
        test: {
            API_BASE_URL: "https://test.xmed.am",
            KEYCLOAK_URL: "https://test.xmed.am/idp/",
            KEYCLOAK_REALM: "products",
            KEYCLOAK_CLIENT_ID: "platform-ui",
        },
        staging: {
            API_BASE_URL: "https://staging.xmed.am",
            KEYCLOAK_URL: "https://staging.xmed.am/idp/",
            KEYCLOAK_REALM: "products",
            KEYCLOAK_CLIENT_ID: "platform-ui",
        },
        prod: {
            API_BASE_URL: "https://xmed.am",
            KEYCLOAK_URL: "https://xmed.am/idp/",
            KEYCLOAK_REALM: "products",
            KEYCLOAK_CLIENT_ID: "platform-ui",
        },
    }

    const selectedConfig = configs[env] || configs.local

    return {
        ...selectedConfig,
        WEBSOCKET_URL: toWebSocketUrl(selectedConfig.API_BASE_URL),
    }
}

export const config = getEnvironmentConfig()


// Debug logging (development only)
if (process.env.NODE_ENV !== "production") {
    console.log("Environment:", process.env.NODE_ENV || process.env.REACT_APP_ENV)
    console.log("Config:", config)
}
